/**
 * Broker Service
 * Retailer broker service for SKU and product management
 */
import { brokerClient } from "./client";

export const brokerService = {
  /**
   * Get list of installation SKUs
   * @param {Object} params - Request parameters
   */
  getInstallationSkuList(params = {}) {
    return brokerClient.post("/iptv-installation-sku-list", params);
  },

  /**
   * Get SKU details
   * @param {string} skuId - SKU ID
   */
  getSkuDetails(skuId) {
    return brokerClient.get(`/sku/${skuId}`);
  },

  /**
   * Get data pack options
   * @param {Object} params - Filter parameters
   */
  getDataPackOptions(params = {}) {
    return brokerClient.post("/datapack/options", params);
  },
};

export default brokerService;
